import React, {
  useEffect,
  useLayoutEffect,
  Fragment,
  useState,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";
import Scrollspy from "react-scrollspy";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import FooterTwo from "../component/footer/FooterTwo";
import Helmet from "../component/common/Helmet";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import logoXrai from "../assets/images/logo/xrailogo.png";
import "../css/BorderTable.css";
import { FinalAddButton, FlexBox, InputBackBox2 } from "../css/BorderPageStyle";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { apiKeyState } from "../atom/ApiKey";
import { apiProductsState } from "../atom/Products";
import { removeCookie } from "../util/Cookie";
import { TokenName } from "../util/Common";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import WysiwygInput from "../component/WysiwygInput";
import { IoIosUnlock } from "react-icons/io";
import {
  AddBackBox,
  AddCheckBoxText,
  AddContentBox,
  AddPageBottomBox,
  AddPageTitleBox,
  ConsentArea,
  ConsentArea2,
  ConsentFirstBox,
  ConsentTitle,
  ConsentTitleBox,
  ContentTitle,
  ContentTitle2,
  FileDeleteBox,
  FileListBox,
  FlexBorder,
  FlexCenter,
  FlexColumnBox,
  FlexMR10,
  FlexSbBox,
  FlexStart,
  InputTextFull,
  MyPcButton,
  MyPcFile,
  SelectBox,
} from "../css/AddTextPageStyle";
import { IoMdClose } from "react-icons/io";
import { ListJoinState, categoryListState } from "../atom/BorderPage";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import Contract from "../component/Contract";
import { BorderCreate } from "../api/border/BorderApi";
import BorderSuccessModal from "../component/modal/BorderSuccessModal";
import BorderFailModal from "../component/modal/BorderFailModal";
import { Header } from "../component/Header";
const AddTextPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [selectedValue, setSelectedValue] = useState("1");
  const categories = useRecoilValue(categoryListState);

  const [isTitle, setTitle] = useState("");
  const [isCompany, setCompany] = useState("");
  const [isPM, setPM] = useState("");
  const [isEmail, setEmail] = useState("");
  const [isPhone, setPhone] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [isCheck, setCheck] = useState(false);
  const [isPw, setPw] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFailModalOpen, setFailIsModalOpen] = useState(false);

  const handleModalClose = () => {
    setIsModalOpen(false);
    history.push("/border");
  };

  const handleFailModalClose = () => {
    setFailIsModalOpen(false);
  };
  const handleTitle = (e) => {
    setTitle(e.target.value);
  };

  const handleCompany = (e) => {
    setCompany(e.target.value);
  };

  const handlePm = (e) => {
    setPM(e.target.value);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handlePhone = (e) => {
    const onlyNumber = e.target.value.replace(/[^0-9]/g, "");
    setPhone(onlyNumber);
  };

  const handleCheck = (e) => {
    setCheck(e.target.checked);
  };

  const handlePw = (e) => {
    setPw(e.target.value);
  };

  const handleEditorChange = (state) => {
    const rawContentState = convertToRaw(state.getCurrentContent());
    const html = draftToHtml(rawContentState);
    setEditorContent(html);
  };

  const addhandleCreat = async (
    title,
    compan,
    category,
    email,
    content,
    pw,
    phone,
    name
  ) => {
    try {
      const resp = await BorderCreate(
        title,
        compan,
        Number(category),
        email,
        content,
        pw,
        phone,
        name
      );
      if (resp.status === 200) {
        setIsModalOpen(true);
      } else {
      }
    } catch (error) {
      console.log("정상적으로 생성안됨", error);
      return error;
    }
  };

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };
  useLayoutEffect(() => {
    const { hash } = location;
    if (hash) {
      const target = document.getElementById(hash.substring(1));
      if (target) {
        console.log(hash, target);
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      var value = window.scrollY;
      if (value > 100) {
        document.querySelector(".header--fixed").classList.add("sticky");
      } else {
        document.querySelector(".header--fixed").classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);

    const elements = document.querySelectorAll(".has-droupdown > a");
    for (let i = 0; i < elements.length; i++) {
      elements[i].onclick = function () {
        this.parentElement.querySelector(".submenu").classList.toggle("active");
        this.classList.toggle("open");
      };
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const logo = {
    // width: "20%",
    width: `150px`,
  };
  const setApiKeys = useSetRecoilState(apiKeyState);
  const setPriducts = useSetRecoilState(apiProductsState);
  const [isToken, setToken] = useState(false);
  const setListJoinState = useSetRecoilState(ListJoinState);

  const haderLogout = () => {
    localStorage.clear();
    setApiKeys([]);
    setPriducts([]);
    setListJoinState([]);
    removeCookie(TokenName);
    history.push("/login");
  };
  const [isFocused, setIsFocused] = useState(false);

  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);

  const handleClickUpload = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setFiles((prev) => [...prev, ...newFiles]);
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const formatBytes = (bytes) => {
    const mb = bytes / 1024 / 1024;
    return `${mb.toFixed(2)} MB`;
  };

  const totalSize = files.reduce((acc, file) => acc + file.size, 0);
  const totalCount = files.length;
  return (
    <Fragment>
      <Helmet pageTitle="XRAI | (주)엑스알에이아이" />
      {/* Start Header Area  */}
      <Header />
      <input
        ref={fileInputRef}
        type="file"
        style={{ display: "none" }}
        multiple
        onChange={handleFileChange}
      />
      <div className="about-area ptb--120 bg_color--5">
        <div className="about-wrapper">
          <FlexColumnBox className="container">
            <AddPageTitleBox>도입문의</AddPageTitleBox>
            <AddBackBox>
              <AddContentBox>
                <FlexCenter>
                  <ContentTitle>문의 유형</ContentTitle>
                  <div>
                    <SelectBox value={selectedValue} onChange={handleChange}>
                      {categories.data &&
                        categories.data
                          .filter((item) => item.id !== 0)
                          .map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.text}
                            </option>
                          ))}
                    </SelectBox>
                  </div>
                </FlexCenter>
              </AddContentBox>
              <AddContentBox>
                <FlexCenter>
                  <ContentTitle>문의 제목</ContentTitle>
                  <div style={{ flex: 1 }}>
                    <InputTextFull
                      value={isTitle}
                      onChange={handleTitle}
                      type="text"
                    ></InputTextFull>
                  </div>
                </FlexCenter>
              </AddContentBox>
              <AddContentBox>
                <FlexCenter>
                  <ContentTitle>회사명</ContentTitle>
                  <div style={{ flex: 1 }}>
                    <InputTextFull
                      value={isCompany}
                      onChange={handleCompany}
                      type="text"
                    ></InputTextFull>
                  </div>
                  <ContentTitle2>담당자</ContentTitle2>
                  <div style={{ flex: 1 }}>
                    <InputTextFull
                      value={isPM}
                      onChange={handlePm}
                      type="text"
                    ></InputTextFull>
                  </div>
                </FlexCenter>
              </AddContentBox>
              <AddContentBox>
                <FlexCenter>
                  <ContentTitle>이메일</ContentTitle>
                  <div style={{ flex: 1 }}>
                    <InputTextFull
                      value={isEmail}
                      onChange={handleEmail}
                      type="text"
                    ></InputTextFull>
                  </div>
                  <ContentTitle2>연락처</ContentTitle2>
                  <div style={{ flex: 1 }}>
                    <InputTextFull
                      value={isPhone}
                      onChange={handlePhone}
                      type="text"
                    ></InputTextFull>
                  </div>
                </FlexCenter>
              </AddContentBox>
              <AddContentBox>
                <FlexStart>
                  <ContentTitle2 justify="center" align="flex-start">
                    문의 내용
                  </ContentTitle2>

                  <div style={{ flex: 1 }}>
                    <WysiwygInput onEditorChange={handleEditorChange} />
                  </div>
                </FlexStart>
              </AddContentBox>

              {/* <AddContentBox>
                <FlexStart>
                  <ContentTitle2 justify="start" align="start">
                    첨부 파일
                  </ContentTitle2>

                  <div style={{ flex: 1 }}>
                    <MyPcFile>
                      <div>
                        <MyPcButton onClick={handleClickUpload}>
                          내 PC
                        </MyPcButton>
                        <MyPcButton
                          onClick={() => setFiles([])}
                          style={{ marginLeft: `10px` }}
                        >
                          전체삭제
                        </MyPcButton>
                      </div>
                      <div>{`${formatBytes(
                        totalSize
                      )} / ${totalCount} 개`}</div>
                    </MyPcFile>
                    <FileListBox
                      onClick={() => {
                        if (files.length === 0) handleClickUpload();
                      }}
                      style={{
                        cursor: files.length === 0 ? "pointer" : "default",
                      }}
                    >
                      {files.length === 0 ? (
                        <FlexBorder
                          style={{
                            display: `flex`,
                            justifyContent: `center`,
                            alignItems: `center`,
                            fontWeight: `800`,
                            fontSize: `16px`,
                          }}
                        >
                          파일을 업로드해주세요.
                        </FlexBorder>
                      ) : (
                        <FlexBorder>
                          {files.map((file, index) => (
                            <FlexSbBox key={index}>
                              <FileDeleteBox>
                                <IoMdClose
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemoveFile(index);
                                  }}
                                  style={{
                                    color: `gray`,
                                    marginRight: `10px`,
                                    cursor: `pointer`,
                                    minHeight: `20px`,
                                    minWidth: `20px`,
                                  }}
                                />
                                <div
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "100%",
                                  }}
                                  title={file.name}
                                >
                                  {file.name}
                                </div>
                              </FileDeleteBox>
                              <FlexMR10>{formatBytes(file.size)}</FlexMR10>
                            </FlexSbBox>
                          ))}
                        </FlexBorder>
                      )}
                    </FileListBox>
                  </div>
                </FlexStart>
              </AddContentBox> */}
              <ConsentTitleBox>
                <ConsentFirstBox>
                  <ConsentTitle>개인정보 수집 및 동의 (필수)</ConsentTitle>
                  <div style={{ flex: 1 }}>
                    <ConsentArea2>
                      <Contract />
                    </ConsentArea2>
                    {/* <ConsentArea readOnly type="text"></ConsentArea> */}
                  </div>
                </ConsentFirstBox>
              </ConsentTitleBox>
              <AddPageBottomBox>
                <FlexBox>
                  <AddCheckBoxText>동의합니다</AddCheckBoxText>
                  <input
                    checked={isCheck}
                    onChange={handleCheck}
                    style={{
                      marginLeft: `10px`,
                      width: `20px`,
                    }}
                    type="checkbox"
                  ></input>
                </FlexBox>
              </AddPageBottomBox>
              <div>
                <div
                  style={{
                    display: `flex`,
                    justifyContent: `center`,
                    alignItems: `center`,
                    marginTop: `20px`,
                    marginBottom: `20px`,
                  }}
                >
                  <InputBackBox2 isFocused={isFocused}>
                    <IoIosUnlock
                      color="gray"
                      size={`30px`}
                      style={{
                        marginRight: `5px`,
                        marginLeft: `5px`,
                      }}
                    />
                    <input
                      value={isPw}
                      onChange={handlePw}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      style={{
                        width: "100%",
                        border: "none",
                        outline: "none",
                        fontSize: "16px",
                      }}
                      type="password"
                    ></input>
                  </InputBackBox2>
                </div>
              </div>
              <FlexBox>
                <FinalAddButton
                  disabled={
                    !isTitle.trim() ||
                    !isCompany.trim() ||
                    !isPM.trim() ||
                    !isEmail.trim() ||
                    !isPhone.trim() ||
                    !editorContent.trim() ||
                    !isPw.trim() ||
                    !isCheck
                  }
                  onClick={() => {
                    addhandleCreat(
                      isTitle,
                      isCompany,
                      selectedValue,
                      isEmail,
                      editorContent,
                      isPw,
                      isPhone,
                      isPM
                    );
                  }}
                >
                  등록하기
                </FinalAddButton>
              </FlexBox>
            </AddBackBox>
          </FlexColumnBox>
        </div>
        <BorderSuccessModal isOpen={isModalOpen} onClose={handleModalClose} />
        <BorderFailModal
          isOpen={isFailModalOpen}
          onClose={handleFailModalClose}
        />
      </div>
      <FooterTwo />
      {/* End Footer Style  */}
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}
    </Fragment>
  );
};

export default AddTextPage;
